import React from "react";
import { useState, useEffect } from "react";
import { fromJS } from "immutable";
import MAP_STYLE from "./Map2Style.json";
import { Button, ButtonGroup, Slider, Typography, Checkbox, FormGroup, FormControlLabel, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";


const defaultMapStyle = fromJS(MAP_STYLE);
const defaultLayers = defaultMapStyle.get("layers");

const PrettoSlider = withStyles({
  root: {
    color: "rgb(190, 215, 71)",
    height: 2,
    marginTop: -10,
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -6,
    marginLeft: -10,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50%)",
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  rail: {
    height: 6,
    borderRadius: 4,
  },
  mark: {
    height: 11,
  },
})(Slider);

const LayerTooltip = withStyles({
  tooltipPlacementRight: {
    left: "18px",
  },
})(Tooltip);

const marks = [
  {
    value: 2012,
    label: "'13",
  },
  {
    value: 2016,
    label: "'16",
  },
  {
    value: 2020,
    label: "'20",
  },
];

function getMapStyle(activeStyle, sliderValue, activeYear, state) {
  let layers = defaultLayers.filter((layer) => {
    const id = layer.get("id");
    const style = layer.getIn(["metadata", "style"]);
    let activeLetterOne = ""
    let activeLetterTwo = ""
    let activeLetterThree = ""
    if (state.a === true) {
      activeLetterOne = "a"
    }
    if (state.t === true) {
      activeLetterTwo = "t"
    }
    if (state.u === true) {
      activeLetterThree = "u";
    }
    const displayLayer = activeLetterOne + activeLetterTwo + activeLetterThree + "_" + activeYear;
    console.log("displayLayer", displayLayer);
    return (
      id === displayLayer || style === activeStyle || id === "summaryStats"
    );
  });
  layers = layers.map((layer) => {
    const style = layer.getIn(["metadata", "style"]);
    const type = layer.get("type");
    const newPaintValue = sliderValue * 0.01;
    if (style === "none" && type === "raster") {
      layer = layer.setIn(["paint", "raster-opacity"], newPaintValue);
    }
    return layer;
  });

  return defaultMapStyle.set("layers", layers);
}

const Map2Control = (props) => {
    const [sliderValue, setSliderValue] = useState(100);
    const [activeStyle, setActiveStyle] = useState("darkSimple");
    const [activeYear, setActiveYear] = useState('2020')
    const state = props.state;
    const setState = props.setState;

    const handleChange = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
    };

    const { a, t, u } = state;
    const handleStyle = (event, newStyle) => {
      setActiveStyle(newStyle);
    };

  useEffect(() => {
    props.onChange(getMapStyle(activeStyle, sliderValue, activeYear, state));
  }, [activeStyle, sliderValue, activeYear, state]);

  return (
    <div>
      <div className="styleButtonsMap2">
      <ButtonGroup
          variant="contained"
          color="primary"
          aria-label="contained primary button group"
        >
            <Button
              value={"satellite"}
              onClick={(e) => setActiveStyle(e.currentTarget.value)}
            >
              Satellite
            </Button>
            <Button
              value={"darkSimple"}
              onClick={(e) => setActiveStyle(e.currentTarget.value)}
            >
              Dark
            </Button>
            <Button
              value={"light"}
              onClick={(e) => setActiveStyle(e.currentTarget.value)}
            >
              Light
            </Button>
          </ButtonGroup>
      </div>

      <div className="map2-opacity">
        <p className="title">
          Opacity: <span id="slider-value">{sliderValue}%</span>
        </p>
        <PrettoSlider
          id="slider"
          min={0}
          max={100}
          step={1}
          value={sliderValue}
          onChange={(event, value) => setSliderValue(value)}
        />
      </div>

    <div className="control-panel-map2">
          <p className="title">Anthropogenic Stressors</p>
          <FormGroup>
            <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> The degree of alteration of the natural environment through the planting and harvesting of crops as well as grazing impacts on pasturelands.</p></>} arrow>
                <FormControlLabel
                  className="formControlLabel"
                  control={<Checkbox checked={a} onChange={handleChange} name="a" />}
                  label="Agriculture"
              />
            </LayerTooltip>

            <LayerTooltip placement="right" title={<><p style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> The footprint of roads, railways, and other modes of transportation as well as their estimated impact on the surrounding environment through noise, fencing, etc.</p> </>} arrow>
              <FormControlLabel
                className="formControlLabel"
                control={<Checkbox checked={t} onChange={handleChange} name="t" />}
                label="Transportation"
              />
            </LayerTooltip>

            <LayerTooltip placement="right" title={<><p style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> The footprint of cities, rural development and other built up areas as well as their estimated impact on the surrounding environment through artificial lighting and other effects.</p> </>} arrow>
              <FormControlLabel
                className="formControlLabel"
                control={<Checkbox checked={u} onChange={handleChange} name="u" />}
                label="Urban"
              />
            </LayerTooltip>
          </FormGroup>

      <p >Year</p>
        <PrettoSlider
          value={activeYear}
          marks={marks}
          min={2012}
          max={2020}
          step={4}
          onChange={(event, value) => setActiveYear(JSON.stringify(value))}
        />

        <Typography variant="subtitle2">*Click a state to view graph data*</Typography>
      </div>

    </div>


  );
};

export default React.memo(Map2Control);

